import { personalInfo } from '../data/portfolio';

export default function Footer() {
  return (
    <footer style={{
      padding: 'clamp(1.5rem, 4vw, 2.5rem) 0',
      borderTop: '1px solid rgba(0,245,255,0.07)',
      background: 'rgba(3,5,8,0.8)',
      backdropFilter: 'blur(20px)',
      position: 'relative',
    }}>
      <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '40%', height: 1, background: 'linear-gradient(to right, transparent, rgba(0,245,255,0.3), transparent)' }} />
      <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
          <div style={{
            width: 28, height: 28,
            background: 'linear-gradient(135deg, var(--cyan), var(--teal))',
            clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 0 12px rgba(0,245,255,0.4)',
          }}>
            <span style={{ fontFamily: 'var(--font-display)', fontSize: '0.5rem', fontWeight: 900, color: '#000' }}>DD</span>
          </div>
          <span style={{ fontFamily: 'var(--font-display)', fontSize: '0.6rem', letterSpacing: '0.06em', color: 'var(--grey2)' }}>
            © {new Date().getFullYear()} Dharshith Dev KP
          </span>
        </div>
        <div style={{ display: 'flex', gap: '1.5rem' }}>
          {[
            { href: personalInfo.github, label: 'GitHub' },
            { href: personalInfo.linkedin, label: 'LinkedIn' },
            { href: `mailto:${personalInfo.email}`, label: 'Email' },
          ].map(({ href, label }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer"
              style={{ fontFamily: 'var(--font-display)', fontSize: '0.6rem', letterSpacing: '0.1em', color: 'var(--grey2)', transition: 'color 0.2s', textTransform: 'uppercase' }}
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--cyan)'; e.currentTarget.style.textShadow = '0 0 10px rgba(0,245,255,0.5)'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--grey2)'; e.currentTarget.style.textShadow = 'none'; }}
            >
              {label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
